import { get, post, put } from '../../common/axiosClient';
import { API } from '../../common/constants/urls';
import { UserDTO } from './auth.type';

export interface AssignRolesRequest {
  UserIds: string[];
  Roles: string[];
}

export interface UserRegisterRequest {
  email: string;
  firstName: string;
  lastName: string;
  roles: string[];
}

export const userService = {
  // Get all users
  getAllUsers: async (): Promise<UserDTO[]> => {
    return await get(`${API.USER}`);
  },

  // Assign roles to users
  assignRoles: async (request: AssignRolesRequest): Promise<UserDTO[]> => {
    return await post(`${API.USER}/assign-roles`, request);
  },

  // Register a new user
  registerUser: async (request: UserRegisterRequest): Promise<any> => {
    return await post(`${API.USER}/register`, request);
  },

  // Get user profile
  getUserProfile: async (userId: string): Promise<any> => {
    return await get(`${API.USER}/profile/${userId}`);
  },

  // Update user profile
  updateUserProfile: async (userId: string, profileData: any): Promise<any> => {
    return await put(`${API.USER}/profile/${userId}`, profileData);
  },
};
